export default class OfferRequestItemService {
  constructor($http) {
    this.$http = $http;
  }

  get_status_options() {
    return [
      {id: 0, title: 'Pending'},
      {id: 1, title: 'Available'},
      {id: 2, title: 'Reserved'},
      {id: 3, title: 'PreOrdered'},
      {id: 4, title: 'Ordered'}
    ];
  }

  delete(item_id) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/delete_offer_request_item',
      {item_id: item_id, authenticity_token: window.token}
    );
  }

  mass_delete(items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/delete_offer_request_items',
      {items: items, authenticity_token: window.token}
    );
  }

  save(item) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/save_offer_request_item',
      {item: item, authenticity_token: window.token}
    );
  }

  mass_save(item, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/save_offer_request_items',
      {item: item, items: items, authenticity_token: window.token}
    );
  }

  mass_update_prices(offer_request_id, items) {
    return this.$http.post(
      '/admin/marketplace/offer_requests/update_offer_request_item_prices',
      {offer_request_id: offer_request_id, items: items, authenticity_token: window.token}
    );
  }
}

OfferRequestItemService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/offer-request-item.service.js